import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class QuestionService {
  private url: string = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) { }

  public getQuestionGroups(caseCode: string, groupLevel: string): Observable<any> {
    return this.http.get(
      this.url + 'unauthenticated/qualitySurveyQuestionGroups', { // TODO: Rename to just questionGroups (LW)
        params: new HttpParams().set('submissionCaseCode', caseCode).set('groupLevel', groupLevel)
      }
    )
  }

  public getQuestions(caseCode: string, groupId: number, serviceItemId: number): Observable<any> {
    return this.http.get(
      this.url + 'unauthenticated/qualitySurveyQuestions', { // TODO: Rename to just questions (LW)
        params: new HttpParams().set('submissionCaseCode', caseCode).set('groupId', groupId.toString()).set('serviceItemId', serviceItemId.toString())
      }
    )
  }

  public submitResponses(caseCode: string, serviceItemId: number, responses): Observable<any> {
    return this.http.post(
      this.url + 'unauthenticated/qualitySurveyQuestions', JSON.stringify(responses), {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        params: new HttpParams().set('submissionCaseCode', caseCode).set('serviceItemId', serviceItemId.toString())
      }
    )
  }

  public submitSurvey(caseCode: string): Observable<any> {
    return this.http.post(
      this.url + 'unauthenticated/submitCaseNoteReviewData?submissionCaseCode=' + caseCode, {}
    )
  }

}
